// HSR çapraz satış: pizza seti kutusu ve sepet önerileri (snippets/hsr-capraz.liquid)
(() => {
  if (window.hsrCapraz) return;
  window.hsrCapraz = true;

  const NOTIFICATION_SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

  function formatMoney(cents, format) {
    const fmt = (value, decimals, thousands = ',', decimal = '.') => {
      const [whole, frac] = (value / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const amounts = {
      amount: () => fmt(cents, 2),
      amount_no_decimals: () => fmt(cents, 0),
      amount_with_comma_separator: () => fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(cents, 0, '.', ','),
      amount_with_space_separator: () => fmt(cents, 2, ' ', ','),
      amount_with_apostrophe_separator: () => fmt(cents, 2, "'", '.'),
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (amounts[key] || amounts.amount)());
  }

  function sectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  async function addToCart(variantIds, sections) {
    const body = { items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })) };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi');
    return data;
  }

  function updateCartSections(sections) {
    if (!sections) return;
    ['cart-icon-bubble', 'cart-notification-button'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && sections[id]) el.innerHTML = sectionInnerHTML(sections[id]);
    });
  }

  function announceCartUpdate(data) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hsr-capraz', cartData: data });
    }
  }

  // Birden çok ürün eklenince Dawn bildirimi tek kalem gösterir; eklenenlerin hepsini ve tek bir öneri listesini göster.
  function openNotification(data) {
    const notification = document.querySelector('cart-notification');
    const container = document.getElementById('cart-notification-product');
    if (!notification || !container || !data.sections) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }

    const doc = new DOMParser().parseFromString(data.sections['cart-notification-product'], 'text/html');
    const offersTemplate = doc.querySelector('[data-hsr-offers]')?.cloneNode(true);
    const offers = new Map();
    const rows = [];
    const seenKeys = new Set();

    data.items.forEach((item) => {
      if (seenKeys.has(item.key)) return;
      seenKeys.add(item.key);
      const el = doc.querySelector(`[id="cart-notification-product-${item.key}"]`);
      if (!el) return;
      el.querySelectorAll('[data-hsr-offer]').forEach((offer) => {
        if (!offers.has(offer.dataset.hsrOffer)) offers.set(offer.dataset.hsrOffer, offer.outerHTML);
      });
      el.querySelectorAll('[data-hsr-offers]').forEach((block) => block.remove());
      rows.push(`<div class="hsr-cn-row">${el.innerHTML}</div>`);
    });

    let offersHTML = '';
    if (offersTemplate && offers.size) {
      offersTemplate.querySelector('[data-hsr-offer-list]').innerHTML = [...offers.values()].join('');
      offersHTML = offersTemplate.outerHTML;
    }

    container.innerHTML = rows.join('') + offersHTML;
    updateCartSections(data.sections);
    notification.setActiveElement?.(document.activeElement);
    document.querySelector('sticky-header')?.reveal?.();
    notification.open();
    announceCartUpdate(data);
  }

  function refreshSet(set) {
    const format = set.dataset.moneyFormat;
    let total = 0;
    let compare = 0;
    let count = 0;

    set.querySelectorAll('.hsr-set__check').forEach((check) => {
      check.closest('.hsr-set__item').classList.toggle('is-off', !check.checked);
      if (!check.checked) return;
      count += 1;
      total += Number(check.dataset.price);
      compare += Number(check.dataset.compare);
    });

    set.querySelector('[data-hsr-total]').textContent = formatMoney(total, format);
    const compareEl = set.querySelector('[data-hsr-compare]');
    compareEl.textContent = formatMoney(compare, format);
    compareEl.hidden = compare <= total;
    const save = set.querySelector('[data-hsr-save]');
    save.querySelector('strong').textContent = formatMoney(compare - total, format);
    save.hidden = compare <= total;
    const pct = set.querySelector('[data-hsr-pct]');
    pct.textContent = `%${compare > total ? Math.floor(((compare - total) * 100) / compare) : 0} kazanç`;
    pct.hidden = compare <= total;

    const button = set.querySelector('[data-hsr-set-add]');
    const setSize = Number(set.dataset.count);
    button.disabled = count === 0;
    button.querySelector('[data-hsr-btn-label]').textContent =
      count === 0 ? 'Ürün seçin' : count === 1 ? 'Sepete ekle' : count === setSize ? 'Seti sepete ekle' : `${count} ürünü sepete ekle`;
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  // "Hemen satın alın" araya giren panel: ödemeye geçmeden önce set ürünlerini önerir.
  // Oturumda bir kez gösterilir; ürün eklenirse sepet bağlantısıyla (/cart/varyant:adet,...) doğrudan ödemeye gider.
  const BUYNOW_SEEN = 'hsrBuynowSeen';
  let buynowBypass = false;
  let buynowState = null;

  function buynowSeen() {
    try {
      return sessionStorage.getItem(BUYNOW_SEEN) === '1';
    } catch (err) {
      return false;
    }
  }

  function markBuynowSeen() {
    try {
      sessionStorage.setItem(BUYNOW_SEEN, '1');
    } catch (err) {
      // depolama kapalıysa panel her tıklamada açılır
    }
  }

  function refreshBuynow(dialog) {
    const selected = [...dialog.querySelectorAll('.hsr-buynow__item:not([hidden]) [aria-pressed="true"]')];
    const extra = selected.reduce((sum, button) => sum + Number(button.closest('.hsr-buynow__item').dataset.price), 0);
    // Paket fiyatı kuruşlu olabilir (674,25 TL); mağaza biçimi yerine tr-TR yazılır.
    const tutar = dialog.dataset.hsrPaket
      ? `${(extra / 100).toLocaleString('tr-TR', { minimumFractionDigits: extra % 100 ? 2 : 0, maximumFractionDigits: 2 })} TL`
      : formatMoney(extra, dialog.dataset.moneyFormat);
    dialog.querySelector('[data-hsr-buynow-label]').textContent = selected.length
      ? `Ekleyip ödemeye geç · +${tutar}`
      : 'Ödemeye geç';
    dialog.querySelector('[data-hsr-buynow-skip]').hidden = selected.length === 0;
  }

  function cartPermalink(lines) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/${lines.map(([id, qty]) => `${id}:${qty}`).join(',')}`;
  }

  function continueNativeBuyNow() {
    const { button, variantId, quantity } = buynowState;
    let leaving = false;
    window.addEventListener('pagehide', () => (leaving = true), { once: true });
    window.addEventListener('beforeunload', () => (leaving = true), { once: true });
    buynowBypass = true;
    button.click();
    buynowBypass = false;
    // Shopify butonu tepki vermezse aynı ürünle ödemeye yine de git
    setTimeout(() => {
      if (!leaving) window.location.href = cartPermalink([[variantId, quantity]]);
    }, 4000);
  }

  window.addEventListener(
    'click',
    (event) => {
      if (buynowBypass || buynowSeen()) return;
      const wrapper = event.target.closest?.('.shopify-payment-button');
      if (!wrapper) return;
      const dialog = document.querySelector('[data-hsr-buynow]');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const scope = wrapper.closest('product-info') || wrapper.closest('.shopify-section') || document;
      const variantId = scope.querySelector('product-form form input[name="id"]')?.value;
      if (!variantId) return;
      const quantity = Math.max(1, parseInt(scope.querySelector('input[name="quantity"]')?.value, 10) || 1);
      const productId = scope.dataset?.productId;

      let visible = 0;
      dialog.querySelectorAll('.hsr-buynow__item').forEach((item) => {
        item.hidden = item.dataset.productId === productId;
        const toggle = item.querySelector('[data-hsr-buynow-toggle]');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = '+ Ekle';
        if (!item.hidden) visible += 1;
      });
      if (!visible) return;
      const images = dialog.querySelectorAll('.hsr-buynow__banner-img');
      images.forEach((img) => (img.hidden = img.dataset.productId === productId));
      dialog.querySelector('[data-hsr-buynow-media]').classList.toggle('is-single', [...images].filter((img) => !img.hidden).length === 1);

      event.preventDefault();
      event.stopImmediatePropagation();
      buynowState = {
        button: wrapper.querySelector('.shopify-payment-button__button') || event.target,
        variantId,
        quantity,
      };
      markBuynowSeen();
      refreshBuynow(dialog);
      dialog.showModal();
    },
    true
  );

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest?.('[data-hsr-buynow]');
    if (!dialog) return;

    if (event.target === dialog || event.target.closest('[data-hsr-buynow-close]')) {
      dialog.close();
      return;
    }

    const toggle = event.target.closest('[data-hsr-buynow-toggle]');
    if (toggle) {
      const pressed = toggle.getAttribute('aria-pressed') !== 'true';
      toggle.setAttribute('aria-pressed', String(pressed));
      toggle.textContent = pressed ? 'Eklendi ✓' : '+ Ekle';
      refreshBuynow(dialog);
      return;
    }

    const go = event.target.closest('[data-hsr-buynow-go]');
    const skip = event.target.closest('[data-hsr-buynow-skip]');
    if (!go && !skip) return;
    const extras = go
      ? [...dialog.querySelectorAll('.hsr-buynow__item:not([hidden])')]
          .filter((item) => item.querySelector('[aria-pressed="true"]'))
          .map((item) => [item.dataset.variant, 1])
      : [];
    dialog.querySelectorAll('button').forEach((button) => (button.disabled = true));
    if (extras.length) {
      // Tandırım paketi: TANDIRIM25 kodu bağlantıya eklenir (çark ödülü canlıysa eklenmez, assets/hsr-paket.js)
      const kod = dialog.dataset.hsrPaket && window.hsrPaketKodu ? window.hsrPaketKodu(true) : '';
      window.location.href = cartPermalink([[buynowState.variantId, buynowState.quantity], ...extras]) + (kod ? `?discount=${encodeURIComponent(kod)}` : '');
      return;
    }
    dialog.close();
    dialog.querySelectorAll('button').forEach((button) => (button.disabled = false));
    continueNativeBuyNow();
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.hsr-set__check')) return;
    const set = event.target.closest('[data-hsr-set]');
    if (set) refreshSet(set);
  });

  document.addEventListener('click', async (event) => {
    const setButton = event.target.closest('[data-hsr-set-add]');
    if (setButton) {
      const set = setButton.closest('[data-hsr-set]');
      const ids = [...set.querySelectorAll('.hsr-set__check:checked')].map((check) => check.dataset.variant);
      if (!ids.length) return;
      const error = set.querySelector('.hsr-set__error');
      error.hidden = true;
      setButton.disabled = true;
      setButton.classList.add('is-busy');
      try {
        const sections = document.querySelector('cart-notification') ? NOTIFICATION_SECTIONS : [];
        openNotification(await addToCart(ids, sections));
      } catch (err) {
        showError(error, err.message);
      } finally {
        setButton.disabled = false;
        setButton.classList.remove('is-busy');
      }
      return;
    }

    const offerButton = event.target.closest('[data-hsr-add]');
    if (!offerButton || offerButton.classList.contains('is-added')) return;
    const block = offerButton.closest('[data-hsr-offers]');
    const reload = block?.dataset.hsrAfter === 'reload';
    const label = offerButton.textContent;
    const error = block?.querySelector('.hsr-offers__error');
    if (error) error.hidden = true;
    offerButton.disabled = true;
    offerButton.textContent = 'Ekleniyor…';
    try {
      const data = await addToCart([offerButton.dataset.hsrAdd], reload ? [] : ['cart-notification-button', 'cart-icon-bubble']);
      if (reload) {
        window.location.reload();
        return;
      }
      updateCartSections(data.sections);
      offerButton.textContent = 'Eklendi ✓';
      offerButton.classList.add('is-added');
      announceCartUpdate(data);
    } catch (err) {
      offerButton.disabled = false;
      offerButton.textContent = label;
      showError(error, err.message);
    }
  });
})();
